import { Id } from 'NSwag/ServerClient/Client.nswag';
import { IMenuItem } from 'Common/Map/OpenLayers/Menu/ContextMenu';

interface IProps {
    text: string;
    parentItem?: string;
    callback?: Function;
    items?: IMenuItem[];
}

export class ContextMenuProperties{

    text: string;

    parentItem: string | undefined;

    callback: Function | undefined;

    items: IMenuItem[] | undefined;

    constructor({ text, parentItem, callback, items }: IProps) {
        this.text = text;
        this.parentItem = parentItem;
        this.callback = callback;
        this.items = items;
    }
}